export const FissionVaultAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newAllowedUniswapPriceDivergence',
        type: 'uint256',
      },
    ],
    name: 'AllowedUniswapPriceDivergenceChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newLowerTickRangePercentage',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newUpperTickRangePercentage',
        type: 'uint256',
      },
    ],
    name: 'DefaultTickRangePercentagesChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'fundTokenAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'usdcTokenAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'mintedSharesAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalDepositInUsdc',
        type: 'uint256',
      },
    ],
    name: 'Deposited',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'positionId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'int24',
        name: 'tickLower',
        type: 'int24',
      },
      {
        indexed: false,
        internalType: 'int24',
        name: 'tickUpper',
        type: 'int24',
      },
    ],
    name: 'ManualPositionOpened',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Paused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newRatioTolerancePercentage',
        type: 'uint256',
      },
    ],
    name: 'RatioTolerancePercentageChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Unpaused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'oldUsdcDepositCap',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newUsdcDepositCap',
        type: 'uint256',
      },
    ],
    name: 'UsdcDepositCapUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'sharesAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'tokensRecipient',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'fundTokensAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'usdcTokensAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalDepositInUsdc',
        type: 'uint256',
      },
    ],
    name: 'Withdrawn',
    type: 'event',
  },
  {
    inputs: [],
    name: 'DEPOSIT_WITHDRAW',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'FISSION_VAULT_ADMIN_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MANUAL_POSITION_MANAGER_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_DEPOSIT_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'allowedUniswapPriceDivergence',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'autoPositionTokenId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'shareTokensAmount_',
        type: 'uint256',
      },
    ],
    name: 'convertSharesToUsdc',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'usdcTokensAmount_',
        type: 'uint256',
      },
    ],
    name: 'convertUsdcToShares',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fundTokensAmount_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'usdcTokensAmount_',
        type: 'uint256',
      },
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'fundTokensAmount_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'usdcTokensAmount_',
        type: 'uint256',
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'address',
                name: 'token',
                type: 'address',
              },
              {
                internalType: 'uint160',
                name: 'amount',
                type: 'uint160',
              },
              {
                internalType: 'uint48',
                name: 'expiration',
                type: 'uint48',
              },
              {
                internalType: 'uint48',
                name: 'nonce',
                type: 'uint48',
              },
            ],
            internalType: 'struct IAllowanceTransfer.PermitDetails[]',
            name: 'details',
            type: 'tuple[]',
          },
          {
            internalType: 'address',
            name: 'spender',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'sigDeadline',
            type: 'uint256',
          },
        ],
        internalType: 'struct IAllowanceTransfer.PermitBatch',
        name: 'permitBatchAllowanceData_',
        type: 'tuple',
      },
      {
        internalType: 'bytes',
        name: 'signature_',
        type: 'bytes',
      },
    ],
    name: 'depositWithPermit2',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'exchangeRate',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fissionUniswapV3Interactor',
    outputs: [
      {
        internalType: 'contract IFissionUniswapV3Interactor',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getFissionVaultData',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'fireblocksWalletAddress',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'fundTokenPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'vaultTVLInUsdc',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'usdcFirst',
            type: 'bool',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'token0',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'token1',
                type: 'address',
              },
              {
                internalType: 'uint24',
                name: 'poolFee',
                type: 'uint24',
              },
            ],
            internalType: 'struct IFissionUniswapV3Interactor.PoolData',
            name: 'poolData',
            type: 'tuple',
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'autoPositionTokenId',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'manualPositionTokenId',
                type: 'uint256',
              },
            ],
            internalType: 'struct IFissionVault.VaultPositionsData',
            name: 'positionsData',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'fundTokensAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'usdcTokensAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalBalanceInUsdc',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct IFissionVault.VaultBalanceData',
                name: 'fireblocksWalletBalance',
                type: 'tuple',
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'fundTokensAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'usdcTokensAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalBalanceInUsdc',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct IFissionVault.VaultBalanceData',
                name: 'autoPositionBalance',
                type: 'tuple',
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'fundTokensAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'usdcTokensAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'totalBalanceInUsdc',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct IFissionVault.VaultBalanceData',
                name: 'manualPositionBalance',
                type: 'tuple',
              },
            ],
            internalType: 'struct IFissionVault.FissionVaultBalances',
            name: 'vaultBalances',
            type: 'tuple',
          },
        ],
        internalType: 'struct IFissionVault.FissionVaultData',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInjector',
    outputs: [
      {
        internalType: 'address',
        name: 'injector_',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getVaultSharesData',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'vaultSharesTokenAddr',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'initialSharesExchangeRate',
            type: 'uint256',
          },
        ],
        internalType: 'struct IFissionVault.FissionVaultSharesData',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getVaultTVLInUsdc',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'fundTokenAddr',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'usdcTokenAddr',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'fireblocksWallet',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'ratioTolerancePercentage',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lowerTickRangePercentage',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'upperTickRangePercentage',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'allowedUniswapPriceDivergence',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'usdcDepositCap',
            type: 'uint256',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'vaultSharesTokenAddr',
                type: 'address',
              },
              {
                internalType: 'uint256',
                name: 'initialSharesExchangeRate',
                type: 'uint256',
              },
            ],
            internalType: 'struct IFissionVault.FissionVaultSharesData',
            name: 'vaultSharesData',
            type: 'tuple',
          },
        ],
        internalType: 'struct IFissionVault.FissionVaultInitParams',
        name: 'initParams_',
        type: 'tuple',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lowerTickRangePercentage',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'manualPositionTokenId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'lowerPositionPriceInUsdc_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'upperPositionPriceInUsdc_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'percentageTVL_',
        type: 'uint256',
      },
    ],
    name: 'openManualPosition',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'openRangePosition',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permissionManager',
    outputs: [
      {
        internalType: 'contract IPermissionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permit2',
    outputs: [
      {
        internalType: 'contract IPermit2',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'positionManager',
    outputs: [
      {
        internalType: 'contract INonfungiblePositionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'priceManager',
    outputs: [
      {
        internalType: 'contract IPriceManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ratioTolerancePercentage',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'rewardsDistributor',
    outputs: [
      {
        internalType: 'contract IFissionRewardsDistributor',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'newValue_',
        type: 'uint256',
      },
    ],
    name: 'setAllowedUniswapPriceDivergence',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'newLowerTickRangePercentage_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'newUpperTickRangePercentage_',
        type: 'uint256',
      },
    ],
    name: 'setDefaultTickRangePercentages',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'contractsRegistryAddr_',
        type: 'address',
      },
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    name: 'setDependencies',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'fireblocksWallet_',
        type: 'address',
      },
    ],
    name: 'setFireblocksWallet',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'injector_',
        type: 'address',
      },
    ],
    name: 'setInjector',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'newRatioTolerancePercentage_',
        type: 'uint256',
      },
    ],
    name: 'setRatioTolerancePercentage',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'usdcDepositCap_',
        type: 'uint256',
      },
    ],
    name: 'setUsdcDepositCap',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalUsdcDeposited',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'upperTickRangePercentage',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'usdcDepositCap',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'vaultBalances',
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: 'uint256',
                name: 'fundTokensAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'usdcTokensAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'totalBalanceInUsdc',
                type: 'uint256',
              },
            ],
            internalType: 'struct IFissionVault.VaultBalanceData',
            name: 'fireblocksWalletBalance',
            type: 'tuple',
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'fundTokensAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'usdcTokensAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'totalBalanceInUsdc',
                type: 'uint256',
              },
            ],
            internalType: 'struct IFissionVault.VaultBalanceData',
            name: 'autoPositionBalance',
            type: 'tuple',
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'fundTokensAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'usdcTokensAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'totalBalanceInUsdc',
                type: 'uint256',
              },
            ],
            internalType: 'struct IFissionVault.VaultBalanceData',
            name: 'manualPositionBalance',
            type: 'tuple',
          },
        ],
        internalType: 'struct IFissionVault.FissionVaultBalances',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'suggestedUsdcAmount_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'suggestedFundAmount_',
        type: 'uint256',
      },
    ],
    name: 'vaultDepositRatio',
    outputs: [
      {
        internalType: 'uint256',
        name: 'usdcAmount_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'fundAmount_',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'newPositionRequired_',
        type: 'bool',
      },
      {
        internalType: 'int24',
        name: 'tickLower_',
        type: 'int24',
      },
      {
        internalType: 'int24',
        name: 'tickUpper_',
        type: 'int24',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'sharesAmount_',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'tokensRecipient_',
        type: 'address',
      },
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const

export const FissionVaultV2EventsAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'mint_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'usdc_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tech_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vault_price',
        type: 'uint256',
      },
    ],
    name: 'Minted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'burn_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'usdc_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tech_amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vault_price',
        type: 'uint256',
      },
    ],
    name: 'Redeemed',
    type: 'event',
  },
] as const
